
import { configureStore } from '@reduxjs/toolkit';
import projectFilterSlice from '../features/projects/projectFilterSlice';
import globalApi from './GlobalApi';

const store = configureStore({
   
   
  

    reducer:{
       
        filterProjects:projectFilterSlice,
        [globalApi.reducerPath]: globalApi.reducer,},

middleware: (getDefaultMiddleware) =>
getDefaultMiddleware().concat(globalApi.middleware),
})

export default store;